import clsx from 'clsx';
import type { ComponentPropsWithoutRef } from 'react';

const WrapperSettings = ({
    children,
    className,
    ...restProps
}: ComponentPropsWithoutRef<'main'>) => {
    return (
        <main
            className={clsx(
                'relative flex flex-1 flex-col overflow-hidden rounded-b-md bg-white dark:bg-icoDarkMode-anthracite lg:flex-row',
                className
            )}
            {...restProps}>
            {children}
        </main>
    );
};

const WrapperSettingsFirstColumn = ({
    children,
    className,
    ...restProps
}: ComponentPropsWithoutRef<'section'>) => {
    return (
        <section
            className={clsx(
                'relative box-border w-full lg:w-2/3 lg:overflow-hidden lg:border-r lg:border-icoGray-300 lg:dark:border-icoDarkMode-beton',
                className
            )}
            {...restProps}>
            {children}
        </section>
    );
};

type WrapperSettingsLastColumnProps = ComponentPropsWithoutRef<'aside'> & {
    hideOnMobile?: boolean;
};
const WrapperSettingsLastColumn = ({
    children,
    className,
    hideOnMobile = true,
    ...restProps
}: WrapperSettingsLastColumnProps) => {
    return (
        <aside
            className={clsx('box-border h-full w-full lg:w-1/3', className, {
                'hidden md:block': hideOnMobile
            })}
            {...restProps}>
            <hr className="max-w[calc(100% - 64px)] mb-8 h-1 border-t border-icoGray-300 dark:border-icoDarkMode-beton lg:hidden" />
            {children}
        </aside>
    );
};

WrapperSettings.WrapperSettingsFirstColumn = WrapperSettingsFirstColumn;
WrapperSettings.WrapperSettingsLastColumn = WrapperSettingsLastColumn;

export default WrapperSettings;
